export const POST_EVENT_COMMENT = 'eventDetails/selfFaultEvaluation/POST_EVENT_COMMENT';
export const GET_COMMENTS = 'eventDetails/selfFaultEvaluation/GET_COMMENTS';
export const DELETE_COMMENT = 'eventDetails/selfFaultEvaluation/DELETE_COMMENT';
export const CLEAR_SELF_EVALUATION_STORE = 'eventDetails/selfFaultEvaluation/CLEAR_SELF_EVALUATION_STORE';
export const SET_SELECTED_CAUSE = 'eventDetails/selfFaultEvaluation/SET_SELECTED_CAUSE';
export const SET_PRESELECTED_CAUSE = 'eventDetails/selfFaultEvaluation/SET_PRESELECTED_CAUSE';
export const INITIALIZE_EVENT_CAUSE_STATE = 'eventDetails/selfFaultEvaluation/INITIALIZE_EVENT_CAUSE_STATE';

export const pageSize = 10;
export const maxCommentSize = 500;
